export const SET_USER_DATA = 'SET_USER_DATA'
export const CLEAR_USER_DATA = 'CLEAR_USER_DATA'
export const SET_SUBSCRIPTION_INFO = 'SET_SUBSCRIPTION_INFO'
export const CLEAR_SUBSCRIPTION_INFO = 'CLEAR_SUBSCRIPTION_INFO'